import type { ScreenSchema } from './types';

/**
 * Schema for the `hotspot-fullscreen` template.
 *
 * This template renders screen-hotspot-fullscreen.vue, which itself renders
 * screen-hotspot plus an additional `instructions` overlay positioned at the
 * top of the fullscreen view.
 *
 * Audio slots:
 *   - `intro`        — instructions (narrated when the section
 *                      becomes active
 */
const hotspotFullscreenSchema: ScreenSchema = {
  template: 'hotspot-fullscreen',
  introKeySuffix: '-instructions',
  slots: {
    intro: {
      parts: [{ field: 'instructions' }]
    }
  }
};

export default hotspotFullscreenSchema;
